const initialState = {
    prenameId: null,
    nameTh: null,
    surnameTh: null,
    nameEn: null,
    surnameEn: null,
    thaiOrOtherNation: "thai",
    nationId: null,
    citizenOrPassport: "passport",
    citizenId: null,
    passportNumber: null,
    mobile: null,
    email: null,
    //------------EducationBankgroundUngrad------------------
    countryIdOfSchool: null,
    schoolName: null,
    provinceIdOfSchool: null,
    schoolId: null,
    schoolTypeId: null,
    educationTypeId: null,
    studyStatusId: null,
    studyTypeId: null,
    schoolLocationThaiOrForeignCountry: "inThai",
    termOfGPA: null,
    GPA: null,

};

import { getField, updateField } from 'vuex-map-fields';

export const applicantInfo = {
    namespaced: true,
    state: initialState,
    getters: {
        getField,
    },
    mutations: {
        updateField,
    },
};